import { Product } from '@apis/index'
import {
  deletesvg,
  edit,
  outlinestore,
  switchOff,
  switchOn,
} from '@assets/icons'
import Analytic from '@commons/cards/analytic'
import DashboardCard from '@commons/cards/dashboard'
import Column from '@components/column'
import Grid from '@components/grid'
import Svg from '@components/svg'
import Table from '@components/table'
import Title from '@components/title'
import { RootState } from '@store/index'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { cardConfig } from '../constant'

const ProductList = () => {
  const {
    items: products,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.products)
  console.log(products)
  const [page, setPage] = useState(1)
  const navigate = useNavigate()
  const data = products.map((product) => ({
    id: product.id,
    image: product.image,
    categoryId: product.category?.id,
    category: product.category?.name || 'N/A',
    productName: product.name,
    addOnsCount: product.addons ? product.addons.length : 0,
    addOns: product.addons ?? [],
    status: product.status,
    description: product.description,
  }))

  const columns = [
    { title: 'Product Name', key: 'productName' },
    {
      title: 'Image',
      key: 'image',
      render: (item) => (
        <div>
          <img
            src={`https://admin.tournaop.com/${item.image}`}
            width={50}
            height={50}
            style={{ objectFit: 'contain' }}
          />
        </div>
      ),
    },
    { title: 'Category', key: 'category' },
    { title: 'Add-ons', key: 'addOnsCount' },
    {
      title: 'Status',
      key: 'status',
      render: (item) => (
        <Svg
          src={item.status ? switchOn : switchOff}
          onClick={async () =>
            await Product.update({
              state: 'products',
              id: item.id,
              data: { categoryId: item.categoryId, status: !item.status },
            })
          }
        />
      ),
    },
  ]

  const fetchProducts = async () => {
    try {
      await Product.list({
        state: 'products',
        params: { page, limit: 30 },
      })
    } catch (error) {
      console.error(error)
    }
  }

  React.useEffect(() => {
    fetchProducts()
  }, [page])

  return (
    <Fragment>
      <Column>
        <DashboardCard cardConfig={cardConfig} />
        <Title
          textone="Store Management >"
          texttwo="Products"
          hasButton
          btnText="Create Product"
          onButtonClick={() =>
            navigate('/admin/store-management/product/create-product')
          }
        />
        <Table
          onPageChange={setPage}
          totalItems={totalItems}
          totalPages={totalPages}
          pageControlled={page}
          itemsPerPage={30}
          data={data}
          columns={columns}
          searchKeys={['category', 'productName']}
          text="Products list"
          icon={outlinestore}
          actions={[
            {
              key: 'edit',
              icon: edit,
              onClick: (item) => {
                const fullProduct = products.find((p) => p.id === item.id)
                navigate(
                  `/admin/store-management/product/update-product/${item.id}`,
                  {
                    state: fullProduct,
                  },
                )
              },
            },
            {
              key: 'delete',
              icon: deletesvg,
              onClick: async (item) =>
                await Product.remove({ id: item.id, state: 'products' }),
            },
          ]}
        />
      </Column>
    </Fragment>
  )
}

export default ProductList
